import { render, staticRenderFns } from "./ModalProductOrderPerformance.vue?vue&type=template&id=edebc3f8&scoped=true"
import script from "./ModalProductOrderPerformance.vue?vue&type=script&lang=js"
export * from "./ModalProductOrderPerformance.vue?vue&type=script&lang=js"
import style0 from "./ModalProductOrderPerformance.vue?vue&type=style&index=0&id=edebc3f8&prod&lang=stylus&scoped=true"
import style1 from "./ModalProductOrderPerformance.vue?vue&type=style&index=1&id=edebc3f8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edebc3f8",
  null
  
)

export default component.exports